import { lazy } from "react";
import type { FeatureRoute } from "../../app/route-types";

/**
 * Masraf ve avans. Ana ekrandaki "Masraf bildir" → /masraf/yeni; onay kartındaki "Fişleri incele"
 * → /masraf/:id. Sunucu bildirimleri avans için /avans/:id kullanır; o yol kalıcı adrese yönlenir.
 */
export const routes: FeatureRoute[] = [
  { path: "masraf", Component: lazy(() => import("./MoneyPage")) },
  { path: "masraf/yeni", Component: lazy(() => import("./NewClaimPage")) },
  { path: "masraf/avans/yeni", Component: lazy(() => import("./NewAdvancePage")) },
  { path: "masraf/avans/:id", Component: lazy(() => import("./AdvancePage")) },
  { path: "masraf/:id", Component: lazy(() => import("./ClaimPage")) },
  { path: "avans/:id", Component: lazy(() => import("./AdvancePage").then((m) => ({ default: m.AdvanceRedirect }))) },
  { path: "finans", Component: lazy(() => import("./FinancePage")) },
];
